// extracted by mini-css-extract-plugin
export default {"blocksSummaryCard":"fractionalBlocksSummary_blocksSummaryCard__xe9wY","grandTotalValue":"fractionalBlocksSummary_grandTotalValue__I+Chj"};